var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('span',_vm._g(_vm._b({class:_vm.customClass},'span',attrs,false),on),[_vm._v(_vm._s(_vm._f("truncate")(_vm.data,_vm.lengthDataToTruncate, '...')))])]}}])},[_c('span',[_vm._v(_vm._s(_vm.data))])])
}
var staticRenderFns = []

export { render, staticRenderFns }